export enum FilterKeys {
  TransactionDate = 'transactionDate',
  Currency = 'currency',
  Channel = 'channel',
  EntityUid = 'entityUid',
}

export enum PageNames {
  ReportScheduler = 'reportScheduler',
  PaymentDashboard = 'paymentDashboard',
  ReportSchedulerForm = 'reportSchedulerForm',
  BlockingRuleSet = 'blockingRuleSet',
}
